/** Step 6 “Messages” incl. “Test flow”. */
const wizMessagesEN = {
  wizMsgTitle: 'Message flow',
  wizMsgSubtitle:
    'SAIA writes every message individually for each candidate – from the briefing, profile and your answers on the approach. The flow branches depending on how the contact reacts.',
  wizMsgChangeApproach: 'Change approach',
  wizMsgChatCount: 'Adjust the number of chat messages.',
  wizMsgChatCountAria: 'Number of chat messages: {{count}}',
  wizMsgChatCountHint: 'max. per candidate, excluding InMails, plus recommendation question (if selected)',
  wizMsgSummary: '{{count}} messages',
  wizMsgSummaryInmails: ', of which {{count}} InMails',
  wizMsgPlanLoading: 'Calculating the flow …',
  wizMsgPlanError: 'The flow could not be calculated.',
  wizMsgTestTitle: 'Test flow',
  wizMsgTestSubtitle:
    'Pick a profile from your search. SAIA writes the complete flow for this person, all messages in the order of the flow – nothing is sent.',
  wizMsgTestRun: 'Test flow',
  wizMsgTestRerun: 'Test again',
  wizMsgNoCandidates:
    'As soon as the first candidates from the search are in, you can test the flow on a real profile.',
  wizMsgCandidatesLoading: 'Loading candidates …',
  wizMsgBlocked: 'Company on blacklist – will not be contacted',
  wizMsgTestLoading:
    'SAIA is writing the complete flow for this profile. This can take a few minutes; the result appears automatically, you do not need to do anything.',
  wizMsgTestPreparing: 'The flow is being saved, the test starts in a moment …',
  wizMsgTestStale: 'Profile or flow changed – click “Test again”.',
  wizMsgTestFor: 'Example for {{name}} · will not be sent',
  wizMsgTestSourceAi: 'Written by SAIA (AI) for this profile',
  wizMsgTestSourceTemplate: 'AI not reachable – template filled with names',
  wizMsgTestError: 'The test failed.',
  wizMsgNoText: '(no message)',
  wizWaitEditHint: 'Change time',
  wizWaitChanged: 'changed',
  wizWaitTitle: 'Change waiting time',
  wizWaitAcceptTitle: 'How long to wait for the acceptance?',
  wizWaitHint: 'Set the time in days, hours and minutes.',
  wizWaitDays: 'Days',
  wizWaitHours: 'Hours',
  wizWaitMinutes: 'Minutes',
  wizWaitDay: 'Day',
  wizWaitHour: 'Hour',
  wizWaitMinute: 'Minute',
  wizWaitDefault: 'Default: {{value}}',
  wizWaitReset: 'Reset to default',
  wizWaitTooShort: 'The time is too short (at least {{min}}).',
  wizWaitTooLong: 'The time is too long (at most 90 days).',
  wizWaitCancel: 'Cancel',
  wizWaitSave: 'Apply',
};
export default wizMessagesEN;
